import { defineAction } from '~/prix'
import { z } from 'zod'
import waterSourceApplicationListAction from './waterSourceApplicationList.action.json' with { type: 'json' }
import { waterSourceApplicationObject } from '../waterSourceApplicationObject'
import { enumerated } from '~/prix/types/enumerated'

const waterSourceApplicationListDefinition = defineAction({
  ...waterSourceApplicationListAction,

  input: z.object({
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      incentiveType: 'Tipo de incentivo',
      value: 'Valor',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(waterSourceApplicationObject), count: z.number() }),
})

export default waterSourceApplicationListDefinition
